var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "section p-0",
    class: `${_vm.searchControlMarginTop}`,
    attrs: {
      "id": "search-query-control"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 px-0"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-start align-items-center w-100"
  }, [_c('div', {
    staticClass: "search-filter-query d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column justify-content-center align-items-center",
    style: {
      minHeight: _vm.searchControlHeight,
      width: '100%'
    }
  }, [_c('div', {
    staticClass: "search-filter-query-text-input",
    class: _vm.searchQueryFilterInputTextClass
  }, [_c('div', {
    staticClass: "search-icon-position",
    style: {
      'right': _vm.searchIconPositionStyle
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "size": "1x",
      "icon": "search"
    }
  })], 1), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "search-query-input-text",
    attrs: {
      "type": "text",
      "placeholder": _vm.inputTextPlaceholder
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.searchQuery = $event.target.value;
      }
    }
  })])])])])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }